import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "faq" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "text-subtitle-underline" }
const _hoisted_5 = { class: "flex items-center px-4 font-semibold" }
const _hoisted_6 = { class: "px-2 text-gray-600" }
const _hoisted_7 = { class: "flex items-start px-4" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('contact_faq.title')), 1),
    (Array.isArray(_ctx.faqCategories) && _ctx.faqCategories.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.faqCategories, (faqCategory) => {
          return (_openBlock(), _createElementBlock("div", {
            key: faqCategory.id,
            class: "mb-6"
          }, [
            _createElementVNode("div", {
              id: `${faqCategory.id}`,
              class: "pt-14 -mt-14"
            }, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(faqCategory.name), 1),
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
                accordion: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqCategory.faqs, (faq) => {
                    return (_openBlock(), _createBlock(_component_el_collapse_item, {
                      key: faq.id,
                      name: faq.id
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-mentalncText text-base" }, "Q.", -1)),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(faq.question), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-semibold text-mentalncText text-base" }, "A.", -1)),
                          _createElementVNode("div", {
                            class: "v-html whitespace-pre-wrap mt-0.5 mb-4 px-2",
                            innerHTML: faq.answer
                          }, null, 8, _hoisted_8)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ], 8, _hoisted_3)
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" よくあるご質問が見つかりませんでした。 ")
        ], 64))
  ]))
}